import { Component } from '@angular/core';

@Component({
  selector: 'app-ixh24',
  templateUrl: './ixh24.component.html',
  styleUrl: './ixh24.component.css'
})
export class Ixh24Component {

}
